let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cI1fz")).then(() => parcelRequire('k9qTQ'));